export enum PromptType {
    POSITIVE, NEGATIVE
}
